<template>
  <div id="app">
    <div class="sticky-nav px-4">
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">Leveringsproducten</h1>
      </div>

      <div class="dropdown">
        <button class="btn btn-dark" type="button" id="dropdownMenuButton" v-on:click="modalToevoegenLeveringsproduct()">
          <i class="fas fa-plus"></i> Leveringsproduct toevoegen
        </button>
      </div>
    </div>

    <br />
    <br />

    <vue-good-table
      v-if="leveringsproducten && leveringsproducten.length"
      class="mb-3 px-4"
      @on-selected-rows-change="selectionChanged"
      @on-cell-click="onRowClick"
      :columns="leveringsproductColumns"
      :rows="leveringsproducten"
      :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPage: 100,
        position: 'bottom',
        perPageDropdown: [25, 50, 100],
        setCurrentPage: 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
        dropdownAllowAll: true,
      }"
      :selectOptions="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
      }"
    />

    <!-- Modal -->
    <div class="modal fade" id="leveringsproductModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ editModalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation">
                <a class="nav-link active show" href="#algemeenTab" aria-controls="algemeenTab" role="tab" data-toggle="tab">Algemeen</a>
              </li>
              <li role="presentation">
                <a class="nav-link" href="#prijzenTab" aria-controls="prijzenTab" role="tab" data-toggle="tab">Prijzen</a>
              </li>
            </ul>

            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="algemeenTab">
                <div v-if="leveringsproduct">
                  <label>Naam</label>
                  <input type="text" class="form-control" v-model="leveringsproduct.naam" placeholder="Naam" />
                  <label>Beschrijving</label>
                  <input type="text" class="form-control" v-model="leveringsproduct.beschrijving" placeholder="Beschrijving" />
                </div>
              </div>
              <div role="tabpanel" class="tab-pane" id="prijzenTab">
                <label>Prijs per ton (€)</label>
                <input type="text" class="form-control" v-model="leveringsproduct.prijs" placeholder="Prijs per ton" />
                <hr />
                <ul id="prijslijst">
                  <li>
                    <span>Container (m²)</span>
                    <span>Max. inhoud (kg)</span>
                    <span>Prijs (€)</span>
                  </li>
                  <li v-for="prijs in prijzen" :key="prijs.id">
                    <input class="form-control" type="text" v-model="prijs.grootte_container" />
                    <input class="form-control" type="text" v-model="prijs.max_inhoud" />
                    <input class="form-control" type="text" v-model="prijs.prijs" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="checkNewLeveringsproduct === false" type="button" class="btn btn-danger" v-on:click="deleteLeveringsproduct()">
              Verwijderen
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Sluiten</button>
            <button v-if="checkNewLeveringsproduct" type="button" class="btn btn-primary" v-on:click="createLeveringsproduct()">
              Opslaan
            </button>
            <button v-else type="button" class="btn btn-primary" v-on:click="updateLeveringsproduct()">Aanpassen</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "bootstrap";
import axios from "axios";

export default {
  name: "app",
  components: {},
  data() {
    return {
      checkNewLeveringsproduct: false,
      importType: "-1",
      importCategory: "-1",
      types: [
        {
          name: "Leveringsproducten",
        },
        {
          name: "Leveringsproducten",
        },
        {
          name: "Leveradressen",
        },
      ],
      editModalTitle: "",
      leveringsproduct: {},
      klanten: {},
      prijzen: {},
      leveringsproducten: {
        attributes: [],
        related: [],
      },
      leveringsproductColumns: [{ label: "Naam", field: "naam", filterOptions: { enabled: true } }],
      attrPos: 0,
    };
  },
  mounted() {
    this.getLeveringsproducten();
  },
  methods: {
    getLeveringsproducten() {
      axios.get("https://hofman.weblion.be/api/leveringsproducten/").then((response) => {
        this.leveringsproducten = response.data;
        console.log(this.leveringsproducten);
      });
    },
    deleteLeveringsproduct() {
      axios
        .delete("https://hofman.weblion.be/api/leveringsproducten/", {
          data: {
            leveringsproduct_id: this.leveringsproduct.id,
          },
        })
        .then((response) => {
          this.getLeveringsproducten();
          $("#leveringsproductModal").modal("hide");
          console.log(response.data);
        });
    },
    updateLeveringsproduct() {
      axios
        .put("https://hofman.weblion.be/api/leveringsproducten/", {
          leveringsproduct: this.leveringsproduct,
        })
        .then(() => {
          axios
            .put("https://hofman.weblion.be/api/prijzen/", {
              prijzen: this.prijzen,
            })
            .then((response) => {
              this.getLeveringsproducten();
              $("#leveringsproductModal").modal("hide");
              console.log(response.data);
            })
            .catch(function(error) {
              console.log(error);
            });
        });
    },
    createLeveringsproduct() {
      axios
        .post("https://hofman.weblion.be/api/leveringsproducten/", {
          leveringsproduct: this.leveringsproduct,
        })
        .then((response) => {
          this.getLeveringsproducten();
          $("#leveringsproductModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    modalToevoegenLeveringsproduct() {
      this.leveringsproduct = {};
      this.editModalTitle = "Leveringsproduct toevoegen";

      this.checkNewLeveringsproduct = true;

      $("#leveringsproductModal").modal("show");
    },
    getPrijzen(leveringsproduct) {
      axios
        .get("https://hofman.weblion.be/api/prijzen/", {
          params: {
            leveringsproduct: leveringsproduct,
          },
        })
        .then((res) => {
          this.prijzen = res.data;
          console.log(this.prijzen);
        });
    },
    onRowClick(table) {
      this.editModalTitle = "Leveringsproduct aanpassen";
      this.leveringsproduct = table.row;

      this.checkNewLeveringsproduct = false;

      this.getPrijzen(this.leveringsproduct.id);

      $("#leveringsproductModal").modal("show");
    },
    selectionChanged(table) {
      this.leveringsproductenSelected = table.selectedRows;
    },
    modalAanpassenLeveringsproduct() {
      this.checkNewLeveringsproduct = false;
      this.editModalTitle = "Leveringsproduct aanpassen";

      $("#leveringsproductModal").modal("show");
    },
    sLeveringsproduct() {
      axios
        .post("https://hofman.weblion.be/api/leveringsproducten/update.php", {
          leveringsproduct: this.leveringsproduct,
        })
        .then((res) => {
          console.log(res);
          this.getLeveringsproducten();
        })
        .then(function() {
          $("#leveringsproductModal").modal("hide");
        });
    },
  },
};
</script>

<style>
button {
  margin-right: 10px;
}
.table thead th {
  text-align: left !important;
}
.pager ul {
  list-style-type: none;
}
.pager ul li {
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input,
.modal select {
  margin-bottom: 5px;
}
.modal-body label {
  display: inline-block;
  width: 32%;
}

.modal-body .form-control {
  display: inline-block;
  width: 68%;
}

.modal-body select {
  text-indent: 5px;
}

#exampleModal input {
  display: block;
  width: 100%;
}

#importModal .modal-body label {
  width: auto;
}

#importModal input,
#importModal select {
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper,
#importModal form {
  width: 100%;
}
#importModal select {
  margin-left: 1%;
}

#importModal .fullw {
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select {
  margin: 0;
}

#importModal .fullw input {
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown {
  display: inline-block;
}
.dropdown-item:hover {
  cursor: pointer !important;
}
.dropdown-item i {
  margin-right: 3px;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 550px;
    margin: 1.75rem auto;
  }
}
.groupedState {
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td {
  padding: 2px 10px;
}

#autoGroupModal .modal-title span {
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input {
  width: 100%;
}

#autoGroupModal .form-check-input {
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
  display: inline-block !important;
  width: 68% !important;
  margin-bottom: 5px !important;
}

.sticky-nav {
  position: fixed;
  height: 150px;
  top: 50;
  z-index: 2;
  background: white;
  padding-top: 10px;
  width: 100%;
  margin-top: -10px;
}

#leveringsproductModal textarea {
  height: 100px;
}

.vgt-wrap {
  margin-top: 120px;
}

label {
  vertical-align: top;
}

[data-g="1"] {
  background: #8cc040;
}

[data-g="0"] {
  background: red;
}
.btn-danger {
  margin-right: 210px;
}
#prijslijst {
  list-style-type: none;
  padding: 0;
}
#prijslijst li input,
#prijslijst li span {
  display: inline-block;
  width: 32%;
}
#prijslijst li span {
  margin-bottom: 5px;
}
#prijslijst li input,
#prijslijst li span {
  margin-right: 2%;
}
#prijslijst li input:last-child,
#prijslijst li span:last-child {
  margin-right: 0%;
}
</style>
